const baseOptions = {
  chart: {
    toolbar: {
      show: false,
    },
    zoom: {
      enabled: false,
    },
    animations: {
      easing: 'easeinout',
      speed: 500,
    },
  },
  dataLabels: {
    enabled: false,
  },
  xaxis: {
    type: 'datetime',
    labels: {
      style: {
        fontSize: '14px',
        fontFamily: 'Inter, Arial, sans-serif',
        fontWeight: '400',
        colors: '#9FABCB',
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
    crosshairs: {
      show: true,
      width: 1,
      position: 'back',
      opacity: 1,
      stroke: {
        color: '#D8E2FF',
        width: 1,
        dashArray: 5,
      },
    },
  },
  yaxis: {
    tickAmount: 4,
    labels: {
      style: {
        fontSize: '14px',
        fontFamily: 'Inter, Arial, sans-serif',
        fontWeight: '400',
        colors: ['#9FABCB'],
      },
    },
  },
  tooltip: {
    theme: 'dark',
  },
  grid: {
    borderColor: '#D8E2FF',
    strokeDashArray: 6,
  },
  legend: {
    show: false,
  },
};

export const createAreaChartOptions = ({
  color,
  colors,
  categories,
  yFormatter,
  tooltipFormatter,
  legend = false,
}) => ({
  ...baseOptions,

  chart: {
    ...baseOptions.chart,
    type: 'area',
    height: 300,
  },

  colors: colors || [color],

  stroke: {
    curve: 'smooth',
    width: 3,
  },

  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.2,
      opacityTo: 0,
      stops: [0, 100],
    },
  },

  markers: {
    size: 0,
    hover: {
      size: 6,
    },
  },

  xaxis: {
    ...baseOptions.xaxis,
    categories,
  },

  yaxis: {
    ...baseOptions.yaxis,
    labels: {
      ...baseOptions.yaxis.labels,
      formatter: yFormatter,
    },
  },

  tooltip: {
    ...baseOptions.tooltip,
    x: {
      format: 'dd MMM yyyy',
    },
    y: {
      formatter: tooltipFormatter,
    },
  },

  legend: {
    ...baseOptions.legend,
    show: legend,
    position: 'top',
    horizontalAlign: 'left',
    fontSize: '14px',
    fontFamily: 'Inter, Arial, sans-serif',
    fontWeight: 400,
    labels: {
      colors: '#FFFFFF',
    },
  },
});

export const createBarChartOptions = ({
  color,
  categories,
  yFormatter,
  tooltipFormatter,
}) => ({
  ...baseOptions,

  chart: {
    ...baseOptions.chart,
    type: 'bar',
    height: 300,
  },

  colors: [color],

  plotOptions: {
    bar: {
      borderRadius: 6,
      borderRadiusApplication: 'end',
      columnWidth: '55%',
    },
  },

  xaxis: {
    ...baseOptions.xaxis,
    categories,
  },

  yaxis: {
    ...baseOptions.yaxis,
    labels: {
      ...baseOptions.yaxis.labels,
      formatter: yFormatter,
    },
  },

  tooltip: {
    ...baseOptions.tooltip,
    x: {
      format: 'dd MMM yyyy',
    },
    y: {
      formatter: tooltipFormatter,
    },
  },
});

export const createLineChartOptions = ({
  colors,
  categories,
  yFormatter,
  tooltipFormatter,
  legend = false,
}) => ({
  ...baseOptions,

  chart: {
    ...baseOptions.chart,
    type: 'line',
    height: 300,
  },

  colors,

  stroke: {
    curve: 'smooth',
    width: 3,
  },

  markers: {
    size: 0,
    strokeWidth: 2,
    hover: {
      size: 6,
    },
  },

  xaxis: {
    ...baseOptions.xaxis,
    categories,
  },

  yaxis: {
    ...baseOptions.yaxis,
    labels: {
      ...baseOptions.yaxis.labels,
      formatter: yFormatter,
    },
  },

  tooltip: {
    ...baseOptions.tooltip,
    x: {
      format: 'dd MMM yyyy',
    },
    y: {
      formatter: tooltipFormatter,
    },
  },

  legend: {
    ...baseOptions.legend,
    show: legend,
    position: 'top',
    horizontalAlign: 'left',
    fontSize: '14px',
    fontFamily: 'Inter, Arial, sans-serif',
    fontWeight: 400,
    labels: {
      colors: '#FFFFFF',
    },
    markers: {
      width: 8,
      height: 8,
      radius: 12,
    },
    itemMargin: {
      horizontal: 12,
    },
  },
});
